<template>
  <b-modal
    id="whats-new"
    ref="whats-new"
    size="lg-size"
    centered
    no-close-on-esc
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="content-wrapper whats-new">
      <div class="content-img">
        <img src="../../../images/whats-new.png" :alt="label.get('whats_new')" />
      </div>
      <div class="content-text">
        <h1>{{label.get('whats_new')}}</h1>
        <h2>{{label.get('the_atto_time_clock_now_on_the_web')}}</h2>
        <div class="content-paragraphs">
          <p>{{label.get('whats_new_paragraph_one')}}</p>
          <p>{{label.get('whats_new_paragraph_two')}}</p>
        </div>
        <button type="button" v-on:click="close">{{label.get('continue')}}</button>
        <span class="content-footer-text">{{label.get('whats_new_paragraph_three')}}</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AppService from "../../core/base/shared/AppService";
export default {
  name: "WhatsNewComponent",
  mounted() {
    this.$refs["whats-new"].show();
  },
  methods: {
    close() {
      this.$store.state.user.intro_step.web_time_clock = true;
      AppService.updateIntroSteps({
        intro_steps: JSON.stringify(this.$store.state.user.intro_step),
      })
        .then(() => {})
        .catch(() => {});
      this.$root.$emit("hideWhatsNew");
    },
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tabletAndMobile {
  @media (max-width: 980px) {
    @content;
  }
}
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */
.modal {
  .modal-dialog.modal-lg-size {
    max-width: 1000px;
    width: 95vw;
    .modal-content {
      overflow-y: auto;
      border-radius: 4px;
      .modal-body {
        .content-wrapper {
          padding: 50px 100px 44px 48px;
          @include tabletAndMobile {
            padding: 40px;
          }
        }
      }
    }
  }
}
.content-wrapper.whats-new {
  height: 100%;
  display: flex;
  align-items: center;
  .content-img {
    img {
      width: 384px;
      height: 506px;
    }
    @include tabletAndMobile {
      display: none;
    }
  }
  .content-text {
    padding-left: 52px;
    @include tabletAndMobile {
      padding-left: 0;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      font-size: 1.375rem;
      line-height: 1.875rem;
      height: 1.875rem;
      font-family: "Calibre-Regular";
      color: #00b9cb;
      margin-bottom: 12px;
    }
    h2 {
      max-width: 300px;
      @include tabletAndMobile {
        width: 100%;
      }
      font-size: 2rem;
      line-height: 2rem;
      height: 4rem;
      letter-spacing: -0.5px;
      color: #000000;
      font-family: "Calibre-Semibold";
      margin-bottom: 15px;
      @include mobile {
        margin-bottom: 35px;
      }
    }
    .content-paragraphs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-size: 1.375rem;
        line-height: 1.875rem;
        font-family: "Calibre-Regular";
        margin-bottom: 2rem;
        &:first-child {
          width: 300px;
          @include tabletAndMobile {
            width: 100%;
          }
        }
        &:last-child {
          width: 420px;
          @include tabletAndMobile {
            width: 100%;
          }
        }
      }
    }
    button {
      width: 180px;
      height: 48px;
      background: #00b9cb;
      color: #ffffff;
      text-transform: capitalize;
      border-radius: 4px;
      font-size: 1.25rem;
      line-height: 1.5rem;
      font-family: "Calibre-Semibold";
      margin-bottom: 32px;
      &:hover {
        background: #0a9ead;
      }
    }
    .content-footer-text {
      font-size: 1.125rem;
      line-height: 1.5rem;
      color: #666666;
      font-family: "Calibre-Regular";
    }
  }
}
</style>
